module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-sn.575e6cc8.png";